<template>
  <div>
    <datalist id="input-list">
      <option v-for="shop in shops">{{ shop.description }}</option>
    </datalist>
    <b-form-input
      autocomplete="off"
      list="input-list"
      v-model="selected"
      v-on:change="shopSelected"
      v-validate="{ required: required }"
      :name="description"
      :state="stateValidation(description)"
      aria-describedby="input-shop"/>
    <b-form-invalid-feedback id="input-shop">
      {{ veeErrors.first(description) }}
    </b-form-invalid-feedback>
  </div>
</template>

<script>
import ShopsApi from "../api/ShopsApi";
import eventBus from '@/EventBus'

export default {
  name: 'ShopSelect',
  props: ['required', 'description'],
  inject: ["parentValidator"],
  data() {
    return {
      selected: null,
      shops: []
    }
  },
  created() {
    eventBus.$on("set-shop", this.showDescription)

    ShopsApi.all().then(shops => {
      this.shops = shops
        .map(shop => {
          shop.description = `${shop.name} - ${shop.city} - ${shop.code}`
          return shop
        })
    })

    this.$validator = this.parentValidator
  },
  methods: {
    reset() {
      this.selected = null
    },
    showDescription(code) {
      this.selected = this.shops.find(shop => shop.code === code).description
    },
    shopSelected() {
      let shopCode = this.selected.split(' - ').pop()
      let shop = this.shops.find(shop => shop.code === shopCode)
      if (shop) {
        this.$emit('input', shop)
        eventBus.$emit('shop-selected', shopCode)
      } else {
        this.selected = undefined
        this.$emit('input', undefined)
      }
    },
    stateValidation(ref) {
      if (this.veeFields[ref] && (this.veeFields[ref].dirty || this.veeFields[ref].validated)) return !this.veeErrors.has(ref)
      else return null
    }
  }
}
</script>
